import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {isMobileOnly as isMobile, isTablet} from 'react-device-detect';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { Container, Row, Col } from 'reactstrap';
import { setOtpVerifyCode, clearOtpCode, hideOtpErrorMessage } from '../cellcomAbroadBlockSlice';

import Config from '../../../../Config';
import OtpInput from 'react-otp-input';
import { otpTitles, createOtpButtonsData, lobbyTabsEnum } from '../cellcomAbroadVariables';
import OtpHeadlineComponent from './OtpHeadlineWrapperComponent';
import CreateOtpButtonComponent from './CreateOtpButtonComponent';
import gaParams from '../../../../utilities/analytics/constants';
import { gaEvent } from '../../../../utilities/analytics/tracking';
import { setOtpError, setRestrictedCodeError } from "app/utilities/authentication/authenticationSlice";

const OtpVerifyCodeComponent = (props) => {

    const handleChange = (otp) => {
      props.setOtpError(null);
      props.setRestrictedCodeError(null);
      if (props.data.otpData.showWrongOtpCodeMessage) {
          props.hideOtpErrorMessage();
      }
      props.setOtpVerifyCode({ verifyCode: otp });
    };


    useExtendedEffect((runSideEffects) => {
        if (runSideEffects()) {
            if (props.data.otpCodeForm.valid === true && props.onSubmit == true) {
                handleChange('clear');
                props.clearCode({ verifyCode: '' });
                //props.onValid(props.otpCodeForm.valid);
            }
        }
    });

    const readyToCreateOtp = () => {
        switch(props.data.activeLobbyTab) {
            case lobbyTabsEnum.PACKAGEEXISTS:


              break;
            case lobbyTabsEnum.BUSINESSACCOUNT:
              if(props.data.startedFromPackage){

            }
            else {
                gaEvent(
                    gaParams.ABROAD_LOBBY_OTP_RESEND_CODE_BUTTON_CLICK_BUSINESS.category,
                    gaParams.ABROAD_LOBBY_OTP_RESEND_CODE_BUTTON_CLICK_BUSINESS.eventType,
                    "SMS"
                );
            }
              break;
            default:
             break;
          }
        props.otpVerifyPhone(false, false); //second parameter - if GA report
    };

    const readyToCreateVoiceOtp = () => {
        switch(props.data.activeLobbyTab) {
            case lobbyTabsEnum.PACKAGEEXISTS:


              break;
            case lobbyTabsEnum.BUSINESSACCOUNT:
              if(props.data.startedFromPackage){

            }
            else {
                gaEvent(
                    gaParams.ABROAD_LOBBY_OTP_RESEND_CODE_BUTTON_CLICK_BUSINESS.category,
                    gaParams.ABROAD_LOBBY_OTP_RESEND_CODE_BUTTON_CLICK_BUSINESS.eventType,
                    "VOICE"
                );
            }
              break;
            default:
             break;
          }
        props.otpVerifyPhone(true, false); //second parameter - if GA report
    };

    const headlineCodeEnterText = () => {
        if(props.data.otpData.step1Ticket && props.data.activeLobbyTab == lobbyTabsEnum.BUSINESSACCOUNT){
            return otpTitles.business.codeEnterText;
        }
        else if(props.data.otpData.step1Ticket && props.data.activeLobbyTab == lobbyTabsEnum.PACKAGEEXISTS){
            return otpTitles.packageExists.codeEnterText;
        }
        return "";
    }

  useEffect(() => {
    if ('OTPCredential' in window) {
      async function fetchOtp() {
        try {
          const otp = await navigator.credentials.get({
            otp: { transport: ['sms'] },
          });
          if (otp?.code) {
            handleChange(otp.code);
          }
        } catch (err) {
          console.error('Error fetching OTP:', err);
        }
      }
      fetchOtp();
    }
  }, []);

    return (

            <Container  className={'otp-verification-bordered-container'}>
                <div className={isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? '' : 'd-flex'}>

                    <Col className={isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? 'col-12' : 'col-3'}>
                        <OtpHeadlineComponent
                            businessOtp = {props.data.activeLobbyTab == lobbyTabsEnum.BUSINESSACCOUNT}
                            description={props.data.activeLobbyTab == lobbyTabsEnum.BUSINESSACCOUNT && !props.data.otpData.step1Ticket ? otpTitles.business.description : ''}
                            isSmallResolution = {props.data.isSmallResolution}
                            isPortrait = {props.data.isPortrait}
                            title={props.data.activeLobbyTab == lobbyTabsEnum.BUSINESSACCOUNT ? otpTitles.business.title : otpTitles.packageExists.title}
                            codeEnterText = {headlineCodeEnterText()}
                        />
                    </Col>
                    <Col className={`${isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? 'col-12' : 'col-4'} main`}>
                        <Row className='otp-verify-code h-100 d-flex flex-wrap align-items-center '>
                            <Col ms={12}>
                                <div className='mainDiv'>
                                    <OtpInput
                                        shouldAutoFocus={true}
                                        value={props.data.otpCodeForm.verifyCode}
                                        onChange={handleChange}
                                        numInputs={6}
                                        isInputNum={true}
                                        separator={<span className='inputSeparator'></span>}
                                        inputStyle='input-design'
                                        inputType="tel"
                                        containerStyle={`mainDivInside`}
                                        name="otp"
                                        renderInput={(inputProps, index) => (
                                          <input
                                            {...inputProps}
                                            key={index}
                                            autoComplete="one-time-code"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                          />
                                        )}
                                    />
                                </div>


                                    <div className='error-container'>
                                      <div className='error'>
                                        {(props.authentication.formError.otpCodeError != null ||  props.data.otpCodeForm.valid == "") && (
                                            <span>{props.authentication.formError.otpCodeError || props.data.otpCodeForm.errors.verifyCode}</span>
                                        )}
                                      </div>
                                    </div>
                                {props.data.otpData.numOfAttempts >= Config.verifyCodeAttemptsLimit ? <div className='error'>לא ניתן לבצע ניסיונות נוספים</div> : ''}
                            </Col>
                        </Row>
                    </Col>


                    <Col className={`${isMobile || (isTablet && props.data.isPortrait) || props.data.isSmallResolution ? 'col-12' : 'col-5'} p-0`}>
                        <div className='main d-flex'>
                            {createOtpButtonsData.map((button, index) => {
                                return <CreateOtpButtonComponent
                                    key={index}
                                    alt={button.alt}
                                    description={button.description}
                                    icon={button.icon}
                                    action={button.id == 'sms' ? readyToCreateOtp : readyToCreateVoiceOtp}
                                />
                            })}
                        </div>
                    </Col>
                </div>
            </Container>

    );
};
const mapStateToProps = (state) => {
    return {
        data: state.cellcomAbroad,
      authentication: state.authentication,

    };
};

const mapDispatchToProps = {
    setOtpVerifyCode,
    clearOtpCode,
    hideOtpErrorMessage,
    setOtpError,
    setRestrictedCodeError
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpVerifyCodeComponent);
